import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import FpDatePickerMonth from '@/components/inputs/FpDatePickerMonth.vue';
import MultiformDictionaries from '@/modules/multiForm/shared/MultiformDictionaries';
import {FFBorrower} from '@/models/ExpertState';
import SimulationFormStep2IncomeSource from '@/components/calculator/form/SimulationFormStep2IncomeSource.vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import EnvironmentService from '@/env/EnvironmentService';
import {Gender} from '@/models/enums/Gender';
import {useInstance} from '@/composables/useInstance';
import {IMultiformDictionaryElement } from '@/modules/multiForm/shared/IMultiformDictionary';
import {Profession} from '@/modules/multiForm/shared/Types';

type ProffesionsListType = Array<IMultiformDictionaryElement<Profession> | {header: string} | {divider: boolean}>;


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormStep2',
  props: {
    borrower: null
  },
  setup(__props: any) {

const props = __props as { borrower: FFBorrower }

const store = useSimulationStore();


const { $snackbarService, } = useInstance();

const residentOptions = [
  { type: true, name_pl: I18NGetter().useSimulationFormStep2.RESIDENT, },
  { type: false, name_pl: I18NGetter().useSimulationFormStep2.NON_RESIDENT, },
] as const;

const hasAdditionalIncomeSourceOptions = [
  { type: true, name_pl: I18NGetter().useSimulationFormStep2.HAS_INCOME, },
  { type: false, name_pl: I18NGetter().useSimulationFormStep2.HAS_NOT_INCOME, },
] as const;

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const dateBefore18Years = `${currentYear - 18}-${currentMonth}`;

const availableProfessions = computed<ProffesionsListType>(() => {
  return [
    {header: I18NGetter().useSimulationFormStep2.TRUSTED_PROFESSIONS,},
    {divider: true,},
    ...MultiformDictionaries.trustedProfessions,
    {header: I18NGetter().useSimulationFormStep2.FINANCE_PROFESSIONS,},
    {divider: true,},
    ...MultiformDictionaries.financeProfessions,
    {header: I18NGetter().useSimulationFormStep2.NATIONAL_ADMINISTRATION_PROFESSIONS,},
    {divider: true,},
    ...MultiformDictionaries.administrationProfessions,
    {header: I18NGetter().useSimulationFormStep2.OTHER_PROFESSIONS,},
    {divider: true,},
    ...MultiformDictionaries.otherProfessions,
  ];
});

const setMaxLoanPeriodBasedOnBirthday = () => {
  if (EnvironmentService.Environment.isAppDomain().NESTO_RO) {
    if (props!.borrower!.birthDate.length === 7) {
      const birthYear: number = parseInt(props!.borrower!.birthDate.slice(3));
      const borrowersAge: number = currentYear - birthYear;
      const retirementAge: number =
        EnvironmentService.Environment.getAppDomainConfig().retirementAge[Gender.MALE];
      const maxLoanPeriod: number = (retirementAge - borrowersAge);
      if (borrowersAge > retirementAge) {
        $snackbarService.openWarningSnackbar(I18NGetter().useSimulationFormStep2.IS_RETIRED);
      } else if (store.userInput!.loanPeriod! > maxLoanPeriod) {
        store.userInput!.loanPeriod = maxLoanPeriod;
        store.userInput!.loanPeriodInMonths = maxLoanPeriod * 12;
        $snackbarService.openWarningSnackbar(I18NGetter().useSimulationFormStep2.SET_MAX_LOAN_PERIOD);
      }
    }
  }
};

return { __sfc: true,store, props, $snackbarService, residentOptions, hasAdditionalIncomeSourceOptions, currentYear, currentMonth, dateBefore18Years, availableProfessions, setMaxLoanPeriodBasedOnBirthday, FpDatePickerMonth, MultiformDictionaries, SimulationFormStep2IncomeSource, I18NGetter }
}

})